import axios from 'axios';
import AwesomeDebouncePromise from 'awesome-debounce-promise';
import { User, defaultUser, Search, getConfiguration } from '../models';
import { FrontPageState } from '../components';

export const getUsers = AwesomeDebouncePromise(async (search: Search): Promise<FrontPageState> => {
    const result = await axios(
        `/titulinis.cfm`,
        {
            params: {
                amzius: search.ageFrom,
                amzius2: search.ageTo,
                lytis: (search.sexMale && search.sexFemale) || (search.sexMale === false && search.sexFemale === false)
                    ? ''
                    : search.sexFemale
                        ? '1'
                        : '2',
                vietove: search.location.id,
                vietovep: search.location.display64,
            },
        }
    );
    return { ...result.data, search: search };
}, 300);